<template>
	<v-container>
		<v-row>
			<v-col
				cols="12"
				sm="6"
				md="4"
				class="pt-6 pt-md-0"
			>
				<v-card
					height="100%"
					class="d-flex flex-column"
				>
					<v-card-title>
						<strong><translate>Insure your device</translate></strong>
					</v-card-title>
					<v-card-subtitle>
						<translate>
							Start typing the brand of your device below and select your model:
						</translate>
					</v-card-subtitle>
					<v-card-text
						class="grow"
					>
						<v-row no-gutters>
							<v-col>
								<device-name-search
									v-model="deviceId"
									endpoint="/api/v0/orders/devices"
									:label="$gettext('Which device is it about?')"
									small-chips
									outlined
									clearable
									hide-details
									color="primary"
									variant="outlined"
									@click:clear="resetPremiums"
									@select="name => input = name"
								/>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions
						class="justify-center ml-2 mr-2"
						style="padding-bottom: 25px"
					>
						<v-btn
							elevation="0"
							block
							variant="elevated"
							rounded
							color="primary"
							:disabled="!input || loading"
							:loading="loading"
							@click="getPremiums()"
						>
							<translate>Calculate Premium</translate>...
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
			<v-col
				cols="12"
				sm="6"
				md="4"
				class="pt-6 pt-md-0"
			>
				<product-card
					:complete="false"
					:price="essentialPrice"
					:device-name="prices === null ? null : deviceName"
					:readonly="readonly"
					height="100%"
					@selected="checkout(false)"
				/>
			</v-col>
			<v-col
				cols="12"
				sm="6"
				md="4"
				class="pt-6 pt-md-0"
			>
				<product-card
					:complete="true"
					:price="completePrice"
					:device-name="prices === null ? null : deviceName"
					:readonly="readonly"
					height="100%"
					@selected="checkout(true)"
				/>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>

import {
	axios,
} from '../../services/axios-service';
import {
	getDomain,
} from '../../services/domain-service.js';
import ProductCard from '../molecules/ProductCard.vue';

export default {
	name: 'HomepagePremiums',
	components: {
		ProductCard
	},

	props: {
		readonly: {
			type: Boolean,
			default: true
		}
	},

	data () {
		return {
			deviceId: null,
			deviceName: null,
			input: null,
			essentialPrice: 1.95,
			completePrice: 3.45,
			prices: null,
			domain: '',
			data: null,
			essentialInsurance: null,
			completeInsurance: null,
			loading: false
		};
	},

	watch: {
		/**
		 * If device id is cleared reset premiums to default
		 *
		 * @param {string|null} newVal
		 */
		deviceId (newVal) {
			if (newVal === null) {
				this.resetPremiums();
			}
		}
	},

	created () {
		this.domain = getDomain();
		this.getInsurances();
	},

	methods: {

		/**
		 * Reset the text, essential price and complete price for the premium
		 *
		 * @returns {void}
		 */
		resetPremiums () {
			this.deviceName = null;
			this.deviceId = null;
			this.prices = null;
			this.essentialPrice = 1.95;
			this.completePrice = 3.45;
		},

		/**
		 * Retrieve the premiums if the device id is set
		 *
		 * @returns {void}
		 */
		getPremiums () {
			this.loading = true;
			if (this.deviceId !== null) {
				axios.get(`/api/v0/prices?device=${this.deviceId}&domain=${this.domain}`)
					.then(({
						data
					}) => {
						if (data.success) {
							this.deviceName = this.input;
							this.prices = data.prices;
							this.essentialPrice = this.prices[this.essentialInsurance];
							this.completePrice = this.prices[this.completeInsurance];
						}
					}).catch((error) => {
						this.resetPremiums();
						window.captureException(error);
					}).finally(() => {
						this.loading = false;
					});
			}
		},

		/**
		 * Get products/insurance ids for the current domain
		 *
		 * @returns {void}
		 */
		getInsurances () {
			axios.get('/api/v0/products/currentproducts')
				.then(({
					data
				}) => {
					data.forEach((insurance) => {
						if (insurance.domainName.toLowerCase() === this.domain) {
							if (insurance.name === 'Mobile Essential') {
								this.essentialInsurance = insurance.id;
							} else {
								this.completeInsurance = insurance.id;
							}
						}
					});
				})
				.catch((error) => {
					window.captureException(error);
				});
		},

		/**
		 * @param {boolean} complete
		 */
		checkout (complete) {
			const productVersionId = complete ? this.completeInsurance : this.essentialInsurance;

			window.location.href = `/checkout?device=${this.deviceId}&productversion=${productVersionId}&domain=${this.domain}`;
		},
	}
};
</script>
